import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labMasterTradeNewRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/master_trades/new',
  staticData: { fullScreen: true },
}).lazy(() =>
  import('pages/lab/Trades/LabMasterTrades/LabMasterTradeNewPage/MasterTradeNewPage').then(
    (d) => d.Route
  )
);
